export interface SubscriptionDetail {
  id: number;
  name: string;
  description: string;
  base_cost: number;
  discount: number;
  is_active: boolean;
  is_recommended: boolean;
  has_subscription_cards: boolean;
  has_accounting: boolean;
  cards_max: number;
  features: Array<string>;
  yearly_cost: number;
  monthly_cost: number;
}

export interface SubscriptionPayload {
  package: number;
  frequency: SubscriptionFrequency;
}

export interface SubscriptionInvoice {
  id: number;
  amount: string;
  invoice_number: string;
  created: Date;
}

export interface CurrentSubscription {
  id: string;
  date_start: string;
  date_end: string;
  date_next_payment: string;
  frequency: SubscriptionFrequency;
  status: SubscriptionStatus;
  upcoming_amount: string;
  package: SubscriptionDetail;
  payment_method: PaymentMethod;
  payfast_token: string;
}

export interface PaymentMethod {
  card_number: string;
  card_expiry: string;
}

export interface SubscriptionCancel {
  reason: number;
}

export interface SubscriptionCancelReasons extends SubscriptionCancel {
  id: number;
}

export interface SubscriptionCancelResponse {
  date_end: string;
  id: number;
}

export interface SubscriptionProRata {
  pro_rata: string;
}

export interface SubscriptionPaymentRequest {
  frequency?: SubscriptionFrequency;
  package?: number;
  return_url: string;
  cancel_url: string;
}

export interface SubscriptionPaymentResponse {
  payment_form_data: unknown;
  payment_form_url: string;
}

export enum SubscriptionStatus {
  New = 'New',
  Active = 'Active',
  Cancelled = 'Cancelled',
}

export enum SubscriptionFrequency {
  YEARLY = 'Yearly',
  MONTHLY = 'Monthly',
}
